import * as API from '@/services/API';

export default {
  getTasks({ commit }, filters) {
    return API.apiClient
      .get('/teams/tasks', { params: filters })
      .then((response) => {
        commit('SET_TASKS', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  getStatsLeads({ commit }) {
    return API.apiClient
      .get('/teams/stats/leads')
      .then((response) => {
        commit('SET_STATS_LEADS', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
        throw error;
      });
  },
  getStatsOpportunities({ commit }) {
    return API.apiClient
      .get('/teams/stats/opportunities')
      .then((response) => {
        commit('SET_STATS_OPPORTUNITIES', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
        throw error;
      });
  },

  getStatsSales({ commit }) {
    return API.apiClient
      .get('/teams/stats/sales')
      .then((response) => {
        commit('SET_STATS_SALES', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
        throw error;
      });
  },
  async addInvitation({ commit, dispatch }, payload) {
    await API.apiClient
      .post('teams/' + payload.team + '/members', payload)
      .then(() => {
        dispatch('getInvitations');
      })
      .catch((error) => {
        throw error;
      });
  },
  getInvitations({ commit, rootGetters }) {
    return API.apiClient
      .get('teams/' + rootGetters['auth/authUser'].current_team.id + '/invitations')
      .then((response) => {
        commit('SET_INVITATIONS', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  getMembers({ commit, rootGetters }) {
    return API.apiClient
      .get('teams/' + rootGetters['auth/authUser'].current_team.id + '/members')
      .then((response) => {
        commit('SET_MEMBERS', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  async deleteMember({ commit, rootGetters }, userId) {
    await API.apiClient
      .delete('teams/' + rootGetters['auth/authUser'].current_team.id + '/members/' + userId)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  async deleteInvitation({ commit, dispatch }, invitation) {
    await API.apiClient
      .delete('teams/invitations/' + invitation)
      .then(() => {
        dispatch('getInvitations');
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  async update({ commit, rootGetters }, payload) {
    await API.apiClient
      .post('teams/' + rootGetters['auth/authUser'].current_team.id, payload)
      .then(() => {})
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  show({ commit, rootGetters }) {
    return API.apiClient
      .get('teams/' + rootGetters['auth/authUser'].current_team.id)
      .then((response) => {
        commit('SET_CURRENT_TEAM', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  async getSubscription({ commit }) {
    return await API.apiClient
      .get('/stripe/subscription')
      .then((response) => {
        commit('SET_SUBSCRIPTION', response.data);
      })
      .catch((error) => {
        console.log(error);
        commit('SET_SUBSCRIPTION', false);
        //   //commit('SET_ERROR', error, { root: true });
      });
  },
};
